interface CalculateNextContributionInput {
	today: Date;
	day: number | undefined;
	periodicity: string | undefined;
}

const calculateNextIndividualContributionDate = ({
	today,
	day,
	periodicity
}: CalculateNextContributionInput): Date | null => {
	if (periodicity !== 'MONTHLY') return null;
	if (typeof day !== 'number' || day < 1 || day > 31) return null;

	const targetYear = today.getUTCFullYear();
	const targetMonth = today.getUTCMonth();
	const todayDay = today.getUTCDate();

	const buildDateCappedToMonthEnd = (year: number, month: number, desiredDay: number) => {
		const lastDayOfMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
		const actualDay = Math.min(desiredDay, lastDayOfMonth);
		return new Date(Date.UTC(year, month, actualDay));
	};

	if (todayDay <= day) {
		return buildDateCappedToMonthEnd(targetYear, targetMonth, day);
	}

	const nextMonth = targetMonth + 1;
	const rolloverYear = nextMonth > 11 ? targetYear + 1 : targetYear;
	const normalizedMonth = nextMonth > 11 ? 0 : nextMonth;
	return buildDateCappedToMonthEnd(rolloverYear, normalizedMonth, day);
};

export default calculateNextIndividualContributionDate;
